import { IVec3, Vec3 } from "./Vec3";

export interface ILine3 {
  from: IVec3;
  to: IVec3;
}

export class Line3 {
  static getNearestPoint(from: IVec3, to: IVec3, otherPoint: IVec3, useRay?: boolean): IVec3 {
    const ap = Vec3.sub(otherPoint, from);
    const ab = Vec3.sub(to, from);
    const projected = Vec3.project(ap, ab);
    const dot = Vec3.dot(ab, projected);
    if (!useRay) {
      if (dot < 0) return from;
      if (dot > 0 && Vec3.len(projected) > Vec3.len(ab)) return to;
    }

    const ps = Vec3.add(from, projected);
    return ps;
  }
}
